import { render } from "./static-content-create.vue?vue&type=template&id=54da248b"
import script from "./static-content-create.vue?vue&type=script&lang=js"
export * from "./static-content-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__